<template>
  <vis-login-layout>
    <vis-loading size="md" v-if="loading" />
    <vis-error size="md" v-else-if="error" :state="state">{{
      $t("resetPassword.linkNotValid")
    }}</vis-error>
    <div v-else class="ba-w-full ba-justify-center ba-content-start">
      <h4
        class="ba-w-full ba-text-xl md:ba-text-2xl ba-mb-4 xs:ba-mb-6 ba-text-center"
      >
        {{ $t("resetPassword.title") }}
      </h4>
      <p class="ba-my-4 ba-text-sm ba-text-center ba-max-w-xs">
        {{ $t("resetPassword.contactCenter") }}
        <a href="mailto:center@artek.org">center@artek.org</a>
      </p>
      <p v-if="userEmail" class="ba-text-center ba-text-sm ba-mb-4 ba-w-full">
        <span class="far fa-user ba-text-sm ba-mb-1 ba-mr-1" />
        <span>{{ userEmail }}</span>
      </p>
      <form
        @submit.prevent="resetPasswordFormSubmit"
        class="ba-w-full ba-justify-center ba-max-w-xs ba-relative ba-pt-4"
      >
        <vis-form-messages
          v-if="formError"
          :form-error-message="$t('resetPassword.formError')"
          :form-field-messages="formFieldMessages"
        />
        <p
          v-if="formSuccess"
          class="success form-message ba-text-center ba-text-sm"
        >
          {{ $t("resetPassword.formSuccess") }}
        </p>
        <p
          v-if="formFieldsRequired"
          class="error form-message ba-text-center ba-text-sm"
        >
          {{ $t("resetPassword.formFieldsRequired") }}
        </p>
        <p
          v-if="formInvalidComparePassword"
          class="error form-message ba-text-center ba-text-sm"
        >
          {{ $t("resetPassword.formInvalidComparePassword") }}
        </p>
        <vis-form-input
          v-model="form.password"
          :disabled="formLoading"
          :label="$t('resetPassword.newPasswordLabel')"
          type="password"
          icon="fas fa-unlock-alt"
          autocomplete="off"
        />
        <vis-form-input
          v-model="form.repeatPassword"
          :disabled="formLoading"
          :label="$t('resetPassword.repeatPasswordLabel')"
          type="password"
          icon="fas fa-unlock-alt"
          autocomplete="off"
        />
        <button
          type="submit"
          :disabled="formLoading"
          class="ap-button-login ba-mt-15 ba-mx-auto ba-transition-all artek-gradient-light"
        >
          {{ $t("button.setPassword") }}
        </button>
      </form>
      <router-link
        :to="{ name: 'login' }"
        class="ba-block ba-text-center ba-w-full"
      >
        <span>{{ $t("backToLogin2") }}</span>
      </router-link>
    </div>
  </vis-login-layout>
</template>

<script>
import VisLoginLayout from "./vis-login-layout";
import { resetPasswordMixin } from "@ba/visary-account-common-vue";
import formMessagesMixin from "@/mixins/form-messages-mixin";

export default {
  name: "vis-page-reset-password",
  components: {
    VisLoginLayout
  },
  mixins: [resetPasswordMixin, formMessagesMixin],
  computed: {
    formMessages() {
      return {
        BadPassword: this.$t("formMessages.badPassword"),
        BadRequest: {
          newPassword: {
            MinLength: this.passwordMinLength,
            MinCapitalLetters: this.passwordMinCapitalLetters,
            MinCursiveLetters: this.passwordMinCursiveLetters,
            MinDigits: this.passwordMinDigits,
            MinSpecialCharacters: this.passwordMinSpecialCharacters,
            MaxLength: this.passwordMaxLength
          }
        }
      };
    }
  }
};
</script>
